// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../rescript/lib/es6/curry.js";
import * as Generic$ApiTypes from "./utils/Generic.bs.js";
import * as ThemeId$ApiTypes from "./ThemeId.bs.js";

var fromJson = Generic$ApiTypes.Decode.string;

var Color = {
  fromJson: fromJson
};

var fromJson$1 = Generic$ApiTypes.Decode.string;

var Px = {
  fromJson: fromJson$1
};

var fromJson$2 = Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string);

var FontFamily = {
  fromJson: fromJson$2
};

var fromJson$3 = Generic$ApiTypes.Decode.simpleVariant([
      [
        "WeightAuto",
        /* WeightAuto */0
      ],
      [
        "WeightThin",
        /* WeightThin */1
      ],
      [
        "WeightLight",
        /* WeightLight */2
      ],
      [
        "WeightNormal",
        /* WeightNormal */3
      ],
      [
        "WeightMedium",
        /* WeightMedium */4
      ],
      [
        "WeightSemiBold",
        /* WeightSemiBold */5
      ],
      [
        "WeightBold",
        /* WeightBold */6
      ]
    ]);

var FontWeight = {
  fromJson: fromJson$3
};

var empty = {
  fontFamily: undefined,
  fontSizeScale: 1.0,
  fontWeight: /* WeightAuto */0
};

var fromJson$4 = Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._1(Generic$ApiTypes.Decode.succeed, (function (fontFamily, fontSizeScale, fontWeight) {
                    return {
                            fontFamily: fontFamily,
                            fontSizeScale: fontSizeScale,
                            fontWeight: fontWeight
                          };
                  })), Curry._2(Generic$ApiTypes.Decode.field, "fontFamily", fromJson$2)), Generic$ApiTypes.Decode.fieldWithDefault("fontSizeScale", Generic$ApiTypes.Decode.$$float, 1.0)), Generic$ApiTypes.Decode.fieldWithDefault("fontWeight", fromJson$3, /* WeightAuto */0));

var Font = {
  FontFamily: FontFamily,
  FontWeight: FontWeight,
  empty: empty,
  fromJson: fromJson$4
};

var fromJson$5 = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.simpleVariant([[
            "NoArt",
            /* NoArt */0
          ]]), [
      Generic$ApiTypes.Decode.deccoVariantWithPayload("GradientArt", Generic$ApiTypes.Decode.string, (function (c) {
              return {
                      TAG: /* GradientArt */0,
                      _0: c
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("ImageArt", Generic$ApiTypes.Decode.string, (function (c) {
              return {
                      TAG: /* ImageArt */1,
                      _0: c
                    };
            }))
    ]);

var Art = {
  fromJson: fromJson$5
};

var fromJson$6 = Curry._2(Generic$ApiTypes.Decode.andThen, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._1(Generic$ApiTypes.Decode.succeed, (function (themeId, themeName, themeCreatedAt, themeUpdatedAt, primaryColor, secondaryColor, tertiaryColor, accentColor, backgroundColor, backgroundArt, placeholderColor, productPromoBackgroundColor, productPromoLabelColor, productPriceDiscountBackgroundColor, productPriceDiscountLabelColor, drawerLabelColor, drawerBackgroundColor, headingFont, bodyFont, buttonFont, roundedEdges, rowGutter, columnGutter, sectionVerticalPadding, sectionPaddingTop, sectionPaddingBottom) {
                                                                                                                    return {
                                                                                                                            themeId: themeId,
                                                                                                                            themeName: themeName,
                                                                                                                            themeCreatedAt: themeCreatedAt,
                                                                                                                            themeUpdatedAt: themeUpdatedAt,
                                                                                                                            primaryColor: primaryColor,
                                                                                                                            secondaryColor: secondaryColor,
                                                                                                                            tertiaryColor: tertiaryColor,
                                                                                                                            accentColor: accentColor,
                                                                                                                            backgroundColor: backgroundColor,
                                                                                                                            backgroundArt: backgroundArt,
                                                                                                                            placeholderColor: placeholderColor,
                                                                                                                            productPromoBackgroundColor: productPromoBackgroundColor,
                                                                                                                            productPromoLabelColor: productPromoLabelColor,
                                                                                                                            productPriceDiscountBackgroundColor: productPriceDiscountBackgroundColor,
                                                                                                                            productPriceDiscountLabelColor: productPriceDiscountLabelColor,
                                                                                                                            drawerBackgroundColor: drawerBackgroundColor,
                                                                                                                            drawerLabelColor: drawerLabelColor,
                                                                                                                            headingFont: headingFont,
                                                                                                                            bodyFont: bodyFont,
                                                                                                                            buttonFont: buttonFont,
                                                                                                                            roundedEdges: roundedEdges,
                                                                                                                            rowGutter: rowGutter,
                                                                                                                            columnGutter: columnGutter,
                                                                                                                            sectionVerticalPadding: sectionVerticalPadding,
                                                                                                                            sectionPaddingTop: sectionPaddingTop,
                                                                                                                            sectionPaddingBottom: sectionPaddingBottom
                                                                                                                          };
                                                                                                                  })), Curry._2(Generic$ApiTypes.Decode.field, "themeId", ThemeId$ApiTypes.fromJson)), Generic$ApiTypes.Decode.fieldWithDefault("themeName", Generic$ApiTypes.Decode.string, "")), Generic$ApiTypes.Decode.fieldWithDefault("themeCreatedAt", Generic$ApiTypes.Decode.$$float, 0)), Generic$ApiTypes.Decode.fieldWithDefault("themeUpdatedAt", Generic$ApiTypes.Decode.$$float, 0)), Generic$ApiTypes.Decode.fieldWithDefault("primaryColor", fromJson, "")), Generic$ApiTypes.Decode.fieldWithDefault("secondaryColor", fromJson, "")), Generic$ApiTypes.Decode.fieldWithDefault("tertiaryColor", fromJson, "")), Generic$ApiTypes.Decode.fieldWithDefault("accentColor", fromJson, "")), Generic$ApiTypes.Decode.fieldWithDefault("backgroundColor", fromJson, "")), Generic$ApiTypes.Decode.fieldWithDefault("backgroundArt", fromJson$5, /* NoArt */0)), Generic$ApiTypes.Decode.fieldWithDefault("placeholderColor", fromJson, "")), Generic$ApiTypes.Decode.fieldWithDefault("productPromoBackgroundColor", fromJson, "")), Generic$ApiTypes.Decode.fieldWithDefault("productPromoLabelColor", fromJson, "")), Generic$ApiTypes.Decode.fieldWithDefault("productPriceDiscountBackgroundColor", fromJson, "")), Generic$ApiTypes.Decode.fieldWithDefault("productPriceDiscountLabelColor", fromJson, "")), Generic$ApiTypes.Decode.fieldWithDefault("drawerLabelColor", fromJson, "")), Generic$ApiTypes.Decode.fieldWithDefault("drawerBackgroundColor", fromJson, "")), Generic$ApiTypes.Decode.fieldWithDefault("headingFont", fromJson$4, empty)), Generic$ApiTypes.Decode.fieldWithDefault("bodyFont", fromJson$4, empty)), Generic$ApiTypes.Decode.fieldWithDefault("buttonFont", fromJson$4, empty)), Generic$ApiTypes.Decode.fieldWithDefault("roundedEdges", fromJson$1, "0px")), Generic$ApiTypes.Decode.fieldWithDefault("rowGutter", fromJson$1, "45px")), Generic$ApiTypes.Decode.fieldWithDefault("columnGutter", fromJson$1, "12px")), Generic$ApiTypes.Decode.fieldWithDefault("sectionVerticalPadding", fromJson$1, "0px")), Generic$ApiTypes.Decode.fieldWithDefault("sectionPaddingTop", Curry._1(Generic$ApiTypes.Decode.nullable, fromJson$1), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("sectionPaddingBottom", Curry._1(Generic$ApiTypes.Decode.nullable, fromJson$1), undefined)), (function (result) {
        return Curry._1(Generic$ApiTypes.Decode.succeed, result);
      }));

var reference_fromJson = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.simpleVariant([[
            "LegacyTheme",
            /* LegacyTheme */0
          ]]), [Generic$ApiTypes.Decode.deccoVariantWithPayload("LinkedTheme", ThemeId$ApiTypes.fromJson, (function (c) {
              return /* LinkedTheme */{
                      _0: c
                    };
            }))]);

var empty_themeId = Curry._1(ThemeId$ApiTypes.fromString, "empty");

var empty_headingFont = {
  fontFamily: undefined,
  fontSizeScale: 1.0,
  fontWeight: /* WeightAuto */0
};

var empty_bodyFont = {
  fontFamily: undefined,
  fontSizeScale: 1.0,
  fontWeight: /* WeightAuto */0
};

var empty_buttonFont = {
  fontFamily: undefined,
  fontSizeScale: 1.0,
  fontWeight: /* WeightAuto */0
};

var empty$1 = {
  themeId: empty_themeId,
  themeName: "",
  themeCreatedAt: 0,
  themeUpdatedAt: 0,
  primaryColor: "#111827",
  secondaryColor: "#374151",
  tertiaryColor: "#6B7280",
  accentColor: "#000000",
  backgroundColor: "#ffffff",
  backgroundArt: /* NoArt */0,
  placeholderColor: "#F3F4F6",
  productPromoBackgroundColor: "#F3F4F6",
  productPromoLabelColor: "#111827",
  productPriceDiscountBackgroundColor: "#dc2626",
  productPriceDiscountLabelColor: "#ffffff",
  drawerBackgroundColor: "#ffffff",
  drawerLabelColor: "#111827",
  headingFont: empty_headingFont,
  bodyFont: empty_bodyFont,
  buttonFont: empty_buttonFont,
  roundedEdges: "4px",
  rowGutter: "45px",
  columnGutter: "12px",
  sectionVerticalPadding: "0px",
  sectionPaddingTop: undefined,
  sectionPaddingBottom: undefined
};

export {
  Color ,
  Px ,
  Font ,
  Art ,
  fromJson$6 as fromJson,
  reference_fromJson ,
  empty$1 as empty,
}
/* fromJson Not a pure module */
